import './structure/ServiceRequest.scss'
import {ReactNode} from 'react'
import {Description} from '../../../genericComponents/typographie/Description'

export const ServiceRequestFormTitleDescription = ({children}: { children: ReactNode }) => {
    return <Description className="service-request-form-title-description">
        {children}
    </Description>
}